export function CategoryFilter({ activeFilter, onFilterChange }) {
  const filters = [
    { key: 'All', label: 'All Sessions', icon: '📋' },
    { key: 'Dev mode', label: 'Dev Mode', icon: '👩‍💻' },
    { key: 'Biz mode', label: 'Biz Mode', icon: '💼' }
  ]

  return (
    <div className="mb-6">
      <div className="flex gap-2 p-1.5 bg-editions-dark-light/50 rounded-xl backdrop-blur-sm border border-editions-purple/20">
        {filters.map(filter => (
          <button
            key={filter.key}
            onClick={() => onFilterChange(filter.key)}
            className={`
              flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium
              transition-all duration-200 touch-manipulation transform hover:scale-105
              ${activeFilter === filter.key
                ? 'bg-editions-purple text-white shadow-lg shadow-editions-purple/30 border border-editions-purple/30'
                : 'text-gray-300 hover:text-white hover:bg-editions-purple/20 hover:shadow-md border border-transparent'
              }
            `}
            aria-label={`Filter by ${filter.label}`}
          >
            <span className="text-base">{filter.icon}</span>
            <span className="hidden sm:inline">{filter.label}</span>
            <span className="sm:hidden">
              {filter.key === 'All' ? 'All' : filter.key.split(' ')[0]}
            </span>
          </button>
        ))}
      </div>
      
      {/* Filter indication */}
      {activeFilter !== 'All' && (
        <div className="mt-3 text-center">
          <span className="text-xs text-gray-400 bg-editions-dark-light/50 px-3 py-1 rounded-full border border-editions-purple/20">
            Showing {activeFilter} sessions only
          </span>
        </div>
      )}
    </div>
  )
} 